import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import GoogleIcon from '@/components/icons/Google';
import { useAppStore } from '@/hooks/useAppStore';
import { useTranslation } from '@/lib/translate';
import { useTheme } from '@/components/themes/ThemeProvider';

/**
 * Login page for admin users.
 */
const AdminLoginPage: React.FC = () => {

  const preferredLanguage = useAppStore((state) => state.preferredLanguage);
  const [loading, setLoading] = React.useState(false);
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error');
  const t = useTranslation(preferredLanguage);
  const clientConfig = useAppStore((state) => state.clientConfig);
  const { resolvedTheme } = useTheme();

  const logoSrc = resolvedTheme === 'dark' && clientConfig?.config?.logoDark
    ? clientConfig.config.logoDark
    : clientConfig?.config?.logo;

  // Google OAuth handler
  const handleGoogleLogin = () => {
    setLoading(true);
    // Redirect to backend's Google OAuth start endpoint
    window.location.href = `/admin/auth/google/login?returnTo=${encodeURIComponent(searchParams.get("returnTo") || "")}`;
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-neutral-900 p-4 login-container">
      <Card className="w-full max-w-sm bg-neutral-900/30 border-neutral-700 text-white rounded-4xl border-0">
        <CardHeader className="text-center">
          <CardTitle className="tracking-[4px] items-center flex justify-center">
            <img src={logoSrc} width="230" />
          </CardTitle>
          <p className="text-neutral-100 text-md font-bold mt-2">{t("Admin Page")}</p>
          {error && <div className="text-red-400 mt-4">Error: <b>{error}</b></div>}
        </CardHeader>

        <CardContent className="pt-4 pb-4">
          <Button onClick={handleGoogleLogin} className="w-full bg-white text-black hover:bg-neutral-200 rounded-xl" disabled={loading}>
            <GoogleIcon className="mr-2 h-5 w-5" />
            {t("Sign in with Google")}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLoginPage;
